import { Canvas } from '@react-three/fiber';
import { OrbitControls, useGLTF } from '@react-three/drei';

const McLarenCanvas = () => {
  const mclaren = useGLTF('./mclaren/scene.gltf');

  return (
    <Canvas 
      className="cursor-pointer" 
      frameloop="demand" 
      camera={{ position: [-6, 4, 9], fov: 45, near: 0.1, far: 200 }}
    >
      <ambientLight intensity={1.2} />
      <directionalLight position={[10, 10, 5]} intensity={2.5} />
      <directionalLight position={[-10, 5, -5]} intensity={1.5} />
      <OrbitControls 
        autoRotate 
        enableZoom={true}
        enablePan={true}
      />
      <primitive object={mclaren.scene} scale={2.5} position={[0, -2.25, 0]} />
    </Canvas>
  );
};

export default McLarenCanvas;
